import { EUserStep } from "@api/models/User";
import { Progress } from "@mantine/core";

export const EProgressColor = {
  GOLD: "gold",
  SUCCESS: "success",
  ...EUserStep,
} as const;

type EProgressColors = (typeof EProgressColor)[keyof typeof EProgressColor];

interface IProgressProps {
  value: number;
  variant?: EProgressColors;
  maximum?: number;
}

const SSProgress: React.FC<IProgressProps> = ({
  value,
  maximum = 100,
  variant = EProgressColor.GOLD,
}) => {
  const progressVariants = {
    [EProgressColor.GOLD]: " gradient-coins ",
    [EProgressColor.SUCCESS]: " gradient-success ",
    [EProgressColor.BRONZE]: " gradient-bronze ",
    [EProgressColor.PLATINE]: " gradient-platine ",
    [EProgressColor.MASTER]: " gradient-master ",
  };

  return (
    <Progress
      value={(value / maximum) * 100}
      classNames={{
        section: `${progressVariants[variant]} bg-no-repeat bg-cover`,
      }}
    />
  );
};

export default SSProgress;
